import { UserPlus2Icon } from "lucide-react"
import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { Button } from "@/components/ui/button"
import { Webhooks } from "@/components/webhooks"
import { FRONTEND_ROUTES } from "@/constants"

export function WebhooksPage() {
  const { t } = useTranslation()

  return (
    <Suspense fallback={<div>{t("common.loading")}</div>}>
      <DashboardContainer>
        <Header>
          <AppBreadcrumb
            links={[
              {
                href: FRONTEND_ROUTES.DASHBOARD.href,
                label: t("sidebar.dashboard"),
              },
              {
                label: t("sidebar.webhooks"),
              },
            ]}
          />
        </Header>
        <section className="flex min-w-0 flex-1 flex-col gap-4 overflow-hidden p-4">
          <div className="flex items-center justify-between">
            <h1 className="page-title">{t("pages.webhooks.title")}</h1>
            <Button asChild>
              <Link to={`${FRONTEND_ROUTES.WEBHOOKS.href}/create`}>
                <UserPlus2Icon size={18} />
                <span className="sr-only sm:not-sr-only sm:ml-2">
                  {t("pages.webhooks.createWebhook")}
                </span>
              </Link>
            </Button>
          </div>
          <Webhooks />
        </section>
      </DashboardContainer>
    </Suspense>
  )
}
